import axios from "axios";
import { adminMainUrl } from "../../../../Config";



//ff -> air -> export -> get query info by quotation
export const getPackageInfoByQuotation = (token, user_id, quotation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_QUERY_INFO_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { quotation_id: quotation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/get-query-info-by-quotation-id`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_QUERY_INFO_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getPackageInfoByQuotation function (redux):", err);
                dispatch({
                    type: "FIND_FF_QUERY_INFO_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getPackageInfoByQuotation function:", error);
            dispatch({
                type: "FIND_FF_QUERY_INFO_FAILURE",
                payload: error,
            });
        }
    };
};


//ff -> air -> export -> job order
export const getFFAirExpJobOrder = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_JOBORDER_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/joborderlist`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_JOBORDER_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpJobOrder function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_JOBORDER_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpJobOrder function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_JOBORDER_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> final Quotation 
export const getFFAirExpFinalQuotation = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_FINAL_QUOTATION_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/final-quotation-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_FINAL_QUOTATION_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpFinalQuotation function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_FINAL_QUOTATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpFinalQuotation function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_FINAL_QUOTATION_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> currency 
export const getFFAirExpCurrency = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_CURRENCY_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/currency/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_CURRENCY_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpCurrency function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_CURRENCY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpCurrency function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_CURRENCY_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> Airport 
export const getFFAirExpAirport = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_AIRPORT_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/airport/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_AIRPORT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpAirport function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_AIRPORT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpAirport function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_AIRPORT_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> Organisation 
export const getFFAirExpOrganisation = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_ORGANISATION_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/organisation-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_ORGANISATION_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpOrganisation function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_ORGANISATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpOrganisation function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_ORGANISATION_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb -> unused hawb List 
export const getFFAirExpUnusedHAWBList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_UNUSED_HAWB_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/get-unused-hawb-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_UNUSED_HAWB_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpUnusedHAWBList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_UNUSED_HAWB_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpUnusedHAWBList function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_UNUSED_HAWB_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb -> unused hawb List  update
export const getFFAirExpUnusedHAWBUpdateList = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_UNUSED_HAWB_UPDATE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/get-all-hawb-list`;
        let body = { id: mawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_UNUSED_HAWB_UPDATE_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpUnusedHAWBUpdateList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_UNUSED_HAWB_UPDATE_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpUnusedHAWBUpdateList function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_UNUSED_HAWB_UPDATE_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> hawbb details 
export const getFFAirExportHAWBDetail = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_HAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/view`;
        let body = { id: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_HAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportHAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_HAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportHAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_HAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> direct MAWB details 
export const getFFAirExporDirectMAWBDetail = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_DIRECT_MAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/direct-shipment/mawb/view`;
        let body = { id: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_DIRECT_MAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExporDirectMAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_DIRECT_MAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExporDirectMAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_DIRECT_MAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb details 
export const getFFAirExportMAWBDetail = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_MAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/view`;
        let body = { id: mawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_MAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportMAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_MAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportMAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_MAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> shipper organisation -> branch list 
export const getFFAirExpShipperBranch = (token, user_id, organisation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_SHIPPER_BRANCH_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { organisation_id: organisation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/organisation-branch-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_SHIPPER_BRANCH_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpShipperBranch function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_SHIPPER_BRANCH_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpShipperBranch function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_SHIPPER_BRANCH_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> shipper organisation -> branch list 
export const getFFAirExpConsigneeBranch = (token, user_id, organisation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { organisation_id: organisation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/organisation-branch-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpConsigneeBranch function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpConsigneeBranch function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export ->  shipper -> organisation -> branch list -> Bank account list
export const getFFAirExpShipperBranchBank = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_SHIPPER_BRANCH_BANK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { branch_id: branch_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/branch-bank-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_SHIPPER_BRANCH_BANK_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpShipperBranchBank function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_SHIPPER_BRANCH_BANK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpShipperBranchBank function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_SHIPPER_BRANCH_BANK_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> consignee -> organisation -> branch list -> Bank account list
export const getFFAirExpConsigneeBranchBank = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_BANK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { branch_id: branch_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/branch-bank-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_BANK_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExpConsigneeBranchBank function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_BANK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExpConsigneeBranchBank function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_CONSIGNEE_BRANCH_BANK_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> console shipment List
export const getFFAirExportConsoleShipmentList = (token, user_id, page_no, ship_status) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_CONSOLE_SHIPMENT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl;
        if (ship_status == "HAWB") {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list`;
            if (page_no) {
                apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list?page=${page_no}`;
            }
        } else if (ship_status == "MAWB") {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/list`;
            if (page_no) {
                apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/list?page=${page_no}`;
            }
        } else {
            throw new Error("Invalid ship status.")
        }
        // console.log(apiUrl);
        // let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list`;
        // if (page_no) {
        //     apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list?page=${page_no}`;
        // }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSOLE_SHIPMENT_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportConsoleShipmentList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSOLE_SHIPMENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportConsoleShipmentList function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_CONSOLE_SHIPMENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> direct shipment List
export const getFFAirExportDirectShipmentList = (token, user_id, page_no) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_DIRECT_SHIPMENT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/direct-shipment/mawb/list`;
        if (page_no) {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/direct-shipment/mawb/list?page=${page_no}`;
        }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_DIRECT_SHIPMENT_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportDirectShipmentList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_DIRECT_SHIPMENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportDirectShipmentList function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_DIRECT_SHIPMENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> console manifest List
export const getFFAirExportConsoleManifestList = (token, user_id, page_no) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/console-manifest/list`;
        if (page_no) {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/console-manifest/list?page=${page_no}`;
        }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportConsoleManifestList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportConsoleManifestList function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> unused mawb in console manifest add form
export const getFFAirExportConsoleManifestMAWBAddList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/console-manifest/unused-mawb-add-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportConsoleManifestMAWBAddList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportConsoleManifestMAWBAddList function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

// //ff -> air -> export -> unused mawb in console manifest edit form
// export const getFFAirExportConsoleManifestMAWBEditList = (token, user_id, console_manifest_id) => {
//     return async function (dispatch) {
//         dispatch({
//             type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_REQUEST",
//         });

//         let config = {
//             // method: "GET",
//             headers: {
//                 'auth-token': token,
//                 'user_id': user_id,
//                 'Content-Type': 'application/json',
//             }
//         };
//         let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/console-manifest/unused-mawb-add-list`;
//         let body = { id: console_manifest_id }
//         try {
//             axios.post(apiUrl, body, config).then((res) => {
//                 dispatch({
//                     type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_SUCCESS",
//                     payload: res?.data?.data,
//                 });
//             }).catch((err) => {
//                 console.log("ERROR in getFFAirExportConsoleManifestMAWBEditList function (redux):", err);
//                 dispatch({
//                     type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_FAILURE",
//                     payload: err,
//                 });
//             });
//         } catch (error) {
//             console.log("Unexpected error in getFFAirExportConsoleManifestMAWBEditList function:", error);
//             dispatch({
//                 type: "FIND_FF_AIR_EXP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_FAILURE",
//                 payload: error,
//             });
//         }
//     };
// };


//calcualte toatl freight in mawb
//ff -> air -> export -> unused mawb in console manifest add form
export const calculateTotalFreightMAWB = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CALCULATE_TOTAL_FREIGHT_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/calculate-hawb-no`;
        let body = { hawb_id_arr: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CALCULATE_TOTAL_FREIGHT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in calculateTotalFreightMAWB function (redux):", err);
                dispatch({
                    type: "FIND_CALCULATE_TOTAL_FREIGHT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in calculateTotalFreightMAWB function:", error);
            dispatch({
                type: "FIND_CALCULATE_TOTAL_FREIGHT_FAILURE",
                payload: error,
            });
        }
    };
};



//ff -> air -> export -> console shipment List
export const getFFAirExportMAWBStockList = (token, user_id, page_no) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_MAWB_STOCK_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawbstock/list?page=${page_no}`;
        // if (ship_status == "HAWB") {
        //     apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list`;
        //     if (page_no) {
        //         apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list?page=${page_no}`;
        //     }
        // } else if (ship_status == "MAWB") {
        //     apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/list`;
        //     if (page_no) {
        //         apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/list?page=${page_no}`;
        //     }
        // } else {
        //     throw new Error("Invalid ship status.")
        // }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_MAWB_STOCK_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportMAWBStockList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_MAWB_STOCK_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportMAWBStockList function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_MAWB_STOCK_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
export const getFFAirExportMAWBStockDetail = (token, user_id, mawb_stock_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_MAWB_STOCK_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let body = { mawb_stock_id: mawb_stock_id }
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawbstock/view`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_MAWB_STOCK_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportMAWBStockDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_MAWB_STOCK_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportMAWBStockDetail function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_MAWB_STOCK_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

export const getFFAirExportHAWBStockList = (token, user_id, page_no) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_HAWB_STOCK_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawbstock/list?page=${page_no}`;
        // if (ship_status == "HAWB") {
        //     apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list`;
        //     if (page_no) {
        //         apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list?page=${page_no}`;
        //     }
        // } else if (ship_status == "MAWB") {
        //     apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/list`;
        //     if (page_no) {
        //         apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/list?page=${page_no}`;
        //     }
        // } else {
        //     throw new Error("Invalid ship status.")
        // }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_HAWB_STOCK_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportHAWBStockList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_HAWB_STOCK_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportHAWBStockList function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_HAWB_STOCK_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
export const getFFAirExportHAWBStockDetail = (token, user_id, mawb_stock_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_HAWB_STOCK_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let body = { hawb_stock_id: mawb_stock_id }
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawbstock/view`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_HAWB_STOCK_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportHAWBStockDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_HAWB_STOCK_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportHAWBStockDetail function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_HAWB_STOCK_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};


//get masters data for dropdown
export const getFFAirExportMAWBStocks = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_MAWB_STOCKS_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawbstock/getunused`;
        if (mawb_id) {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawbstock/getunused?mawb_id=${mawb_id}`;
        }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_MAWB_STOCKS_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportMAWBStocks function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_MAWB_STOCKS_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportMAWBStocks function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_MAWB_STOCKS_FAILURE",
                payload: error,
            });
        }
    };
};
export const getFFAirExportHAWBStocks = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_EXP_HAWB_STOCKS_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawbstock/getunused`;
        if (mawb_id) {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawbstock/getunused?hawb_id=${mawb_id}`;
        }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_EXP_HAWB_STOCKS_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirExportHAWBStocks function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_EXP_HAWB_STOCKS_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirExportHAWBStocks function:", error);
            dispatch({
                type: "FIND_FF_AIR_EXP_HAWB_STOCKS_FAILURE",
                payload: error,
            });
        }
    };
};


export const getDirectMAWBData = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "GET_DIRECT_MAWB_DATA_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/direct-shipment/mawb/get-modal-data?id=${mawb_id}`;
       
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "GET_DIRECT_MAWB_DATA_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getDirectMAWBData function (redux):", err);
                dispatch({
                    type: "GET_DIRECT_MAWB_DATA_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getDirectMAWBData function:", error);
            dispatch({
                type: "GET_DIRECT_MAWB_DATA_FAILURE",
                payload: error,
            });
        }
    };
};


export const getHAWBData = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "GET_HAWB_DATA_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/get-modal-data?id=${mawb_id}`;
       
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "GET_HAWB_DATA_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getDirectMAWBData function (redux):", err);
                dispatch({
                    type: "GET_HAWB_DATA_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getDirectMAWBData function:", error);
            dispatch({
                type: "GET_HAWB_DATA_FAILURE",
                payload: error,
            });
        }
    };
};



export const getConsoleMAWBData = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "GET_CONSOLE_MAWB_DATA_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/console-mawb/get-modal-data?id=${mawb_id}`;
       
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "GET_CONSOLE_MAWB_DATA_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getConsoleMAWBData function (redux):", err);
                dispatch({
                    type: "GET_CONSOLE_MAWB_DATA_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getConsoleMAWBData function:", error);
            dispatch({
                type: "GET_CONSOLE_MAWB_DATA_FAILURE",
                payload: error,
            });
        }
    };
};


export const getDimensionByQuotation = (token, user_id, quotation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "GET_DIMENSION_BY_QUOTATION_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/query-dimensions`;
        let body = {quotation_id : quotation_id};
        try {
            axios.post(apiUrl,body, config).then((res) => {
                dispatch({
                    type: "GET_DIMENSION_BY_QUOTATION_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getDimensionByQuotation function (redux):", err);
                dispatch({
                    type: "GET_DIMENSION_BY_QUOTATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getDimensionByQuotation function:", error);
            dispatch({
                type: "GET_DIMENSION_BY_QUOTATION_FAILURE",
                payload: error,
            });
        }
    };
};